import icon1 from '../images/icons/icon_code.svg'
import icon2 from '../images/icons/icon_programming_tree.svg'
import icon3 from '../images/icons/icon_monitor_2.svg'
import icon4 from '../images/icons/icon_phone.svg'
import icon5 from '../images/icons/icon_bug.svg'
import icon6 from '../images/icons/icon_programming.svg'

import icon7 from '../images/icons/icon_analisis_2.svg'
import icon8 from '../images/icons/icon_process.svg'
import icon9 from '../images/icons/icon_chart_2.svg'
import icon10 from '../images/icons/icon_meeting.svg'
import icon11 from '../images/icons/icon_bulb_2.svg'
import icon12 from '../images/icons/icon_speed_miter.svg'



const Services = [
   
    {
        Id: '6',
        sImg:icon1,
        title: 'Custom Software Development',
        slug: 'Custom Software Development',
        features: ['Software architecture design','Database Management services','Cloud & DevOps services', 'System integration services', 'Data migration services']
    },
    {
        Id: '7',
        sImg:icon2,
        title: 'Website Development Services',
        slug: 'Website-Development-Services',
        features: ['Shopify Development', 'Magento Development', 'Wordpress Development', 'React Development','PHP Development']
    },
    {
        Id: '8',
        sImg:icon3,
        title: 'App Design & Development Services',
        slug: 'App-Design-Development-Services',
        features: ['Mobile App Development', 'UI/UX Design', 'API & Backend Development', 'App Maintenance & Support','iOS, Android, React Native, Flutter']
    },
    {
        Id: '9',
        sImg:icon4,
        title: 'Digital Marketing Services',
        slug: 'Digital-Marketing-Services',
        features: ['Search Engine Optimization', 'Social Media Marketing ', 'Affiliate & Influencer Marketing', 'Pay-Per-Click (PPC) Advertising','Conversion Rate Optimization']
    },
    {
        Id: '10',
        sImg:icon5,
        title: 'Best UI/UX Design Services',
        slug: 'Best-UI/UX-Design-Services',
        features: ['PixelPerfection UI/UX Design', 'DesignCraft UI/UX Design', 'CreativeWave UI/UX Design', 'InterfaceGenius UI/UX Design','DesignXpert Studio']
    },
    {
        Id: '11',
        sImg:icon6,
        title: 'Maintenance and Customer Support',
        slug: 'Maintenance-and-Customer-Support',
    
        features: ['Regular Updates & Bug Fixes', 'Performance Optimization', 'Security Monitoring & Fixes', 'Technical Support ','Hosting & Server Management ']
    },
//     {
//         Id: '12',
//         sImg:icon7,
//         title: 'Strategic Planning and Execution',
//         slug: 'Strategic-Planning-and-Execution',
//         features: [],
//         description:'Our consulting services are customized to suit the unique needs and goals of each client, ensuring precise alignment with their business objectives.',
//     },
//     {
//         Id: '13',
//         sImg:icon8,
//         title: 'Business Process Optimization',
//         slug: 'Business-Process-Optimization',
//         features: [],
//         description:'Our consulting services are customized to suit the unique needs and goals of each client, ensuring precise alignment with their business objectives.',
//     },
//     {
//         Id: '14',
//         sImg:icon9,
//         title: 'Digital Transformation Consulting',
//         slug: 'Digital-Transformation-Consulting',
//         features: [], // 👈 Fix: Empty array added

//         description:'Our consulting services are customized to suit the unique needs and goals of each client, ensuring precise alignment with their business objectives.',
//  },
//     {
//         Id: '15',
//         sImg:icon10,
//         title: 'Strategic Planning and Execution',
//         slug: 'Strategic-Planning-and-Executions',
//         features: [],
//         description:'Our consulting services are customized to suit the unique needs and goals of each client, ensuring precise alignment with their business objectives.',
//     },
//     {
//         Id: '16',
//         sImg:icon11,
//         title: 'Change Management Solutions',
//         slug: 'Change-Management-Solutions',
//         features: [],
//         description:'Our consulting services are customized to suit the unique needs and goals of each client, ensuring precise alignment with their business objectives.',
//     },
//     {
//         Id: '17',
//         sImg:icon12,
//         title: 'Performance Metrics and KPI Development',
//         slug: 'Performance-Metrics-and-KPI-Development',
//         features: [],
//         description:'Our consulting services are customized to suit the unique needs and goals of each client, ensuring precise alignment with their business objectives.',
//     },
]    

export default Services;